import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MobileCheck"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 20.385L13.0575 18.4425L12 19.5L15 22.5L21 16.5L19.9425 15.4425L15 20.385ZM7.5 7.5V21H10.5V22.5H7.5C6.67192 22.4992 6.00083 21.8281 6 21V4.5C6.00083 3.67192 6.67192 3.00083 7.5 3H16.5C17.3281 3.00083 17.9992 3.67192 18 4.5V14.25H16.5V7.5H7.5ZM16.5 4.5H7.5V6H16.5V4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MobileCheck.vue"]]);
